import _ from 'underscore';

// Comparing two objects and get the first different key
export const getObjectsDiffProperty = (obj1 = {}, obj2 = {}) => {
  if (_.isObject(obj1) && _.isObject(obj2)) {
    const allKeys = _.union(_.keys(obj1), _.keys(obj2));

    for (let i = 0; i < allKeys.length; i += 1) {
      const key = allKeys[i];
      if (!_.isEqual(obj1[key], obj2[key])) {
        return key;
      }
    }

    // No difference
    return null;
  }

  return null;
};
